import { Duration } from '@js-joda/core';

import { QrCode } from '@dreryk/react-components';

type CreateAssociationQrCodeProps = {
   readonly secret: string;
   readonly label: string;
   readonly issuer: string;
   readonly windowLength: Duration;
};

export const CreateAssociationQrCode = (props: CreateAssociationQrCodeProps): JSX.Element => {
   const periodInSeconds = props.windowLength.toMillis() / 1000;
   return (
      <QrCode
         value={`otpauth://totp/${props.issuer}:${props.label}?secret=${props.secret}&issuer=${props.issuer}&period=${periodInSeconds}`}
         testId={'mfaSecret'}
         size={150}
      />
   );
};
